// Enable tourguide.js (https://tourguidejs.com/)
const tourTrigger = document.getElementById('tourTrigger')
if (tourTrigger) {
    import("@sjmc11/tourguidejs").then(async (module) => {
        const group = tourTrigger.dataset.tgGroup;
        const response = await fetch('/api/staff/tours/' + group);
        if (response.ok) {
            const data = await response.json();
            const tourSteps = data.content.map(step => ({
                ...step,
                "group": group,
                beforeEnter: async (currentStep, nextStep) => {
                    if (nextStep.wider) {
                        await tg.setOptions({
                            dialogWidth: 1200,
                        });
                    } else {
                        await tg.setOptions({
                            dialogWidth: 380,
                        });
                    }
                    tg.refreshDialog();
                }
            }))

            const tg = new module.TourGuideClient({
                completeOnFinish: true,
                dialogZ: 1100,
                backdropClass: "z-index-toast",
                exitOnClickOutside: false,
                steps: tourSteps,
                dialogMaxWidth: window.innerWidth
            })

            tg.onAfterExit(() => {
                const video = document.querySelector('.tg-dialog video')
                if (video)
                    video.pause()
            })

            const startTourButton = document.getElementById('tourButton')
            if (startTourButton && data.content.length) {
                startTourButton.classList.remove('d-none')
                startTourButton.addEventListener('click', e => {
                    e.preventDefault();
                    tg.start(group)
                })
            }

            if (!tg.isFinished(group)) {
                await tg.start(group)
            }
        } else if (response.status === 404) {
            console.warn(`Missing tour: ${group}`);
        }
    })
}
